<template>
  <section class="copyright-footer">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="5" class="text-left d-flex align-center">
          <v-avatar size="100" class="mb-4">
            <img
              alt="Foto Éder"
              :src="require('@/assets/profile.jpg')"
              cover
              style="
                width: 100%;
                height: 120px;
                object-fit: cover;
                object-position: center -35%;
              "
            />
          </v-avatar>

          <div
            class="text-body-2 text-grey-darken-4 ml-5"
            style="line-height: 1.5; max-width: 60%"
          >
            <p style="font-size: 18px; margin-bottom: 5px">
              Criada por quem domina o assunto:
            </p>
            <strong>Éder Medeiros</strong> — fundador do Maker Market — é
            empreendedor serial e investidor. Anteriormente, fundou o
            <strong>Melhor Envio</strong>, adquirido pela
            <strong>Locaweb</strong>.
          </div>
        </v-col>
        <v-col cols="12" md="7">
          <v-row align="stretch">
            <!-- Coluna 1 -->
            <v-col
              cols="12"
              md="3"
              class="d-flex justify-end align-center mx-auto my-auto margin-md-col-footer"
              style="height: 100%"
            >
              <div>
                <img
                  src="@/assets/logo-horizontal.png"
                  alt="Logo"
                  class="footer-logo"
                />
              </div>
            </v-col>

            <!-- Coluna 2 -->
            <v-col
              cols="12"
              md="3"
              class="text-center"
              style="height: 100%; margin: auto"
            >
              <h3 class="text-subtitle-1 mb-4 ml-6" style="color: #777">
                Apoio institucional:
              </h3>

              <v-row dense class="justify-center">
                <!-- As duas primeiras logos -->
                <v-col
                  v-for="(logo, index) in topLogos"
                  :key="`logo-${index}`"
                  cols="6"
                  class="d-flex justify-center mb-3"
                >
                  <img
                    :src="logo"
                    alt="Logo de apoio"
                    style="height: 60px; max-width: 100px; object-fit: contain"
                  />
                </v-col>

                <!-- Última logo com o texto "Sediada em:" -->
                <v-col cols="12" class="d-flex flex-column align-center">
                  <div class="text-subtitle-1 mt-6 mb-4" style="color: #777">
                    Sediada em:
                  </div>
                  <img
                    :src="lastLogo"
                    alt="Logo de apoio"
                    style="height: 60px; max-width: 100px; object-fit: contain"
                  />
                </v-col>
              </v-row>
            </v-col>

            <!-- Coluna 3 -->
            <v-col
              cols="12"
              md="3"
              class="text-center"
              style="height: 100%; margin: auto"
            >
              <h3 class="text-subtitle-1 mb-4" style="color: #777">
                Nossos links:
              </h3>
              <!-- Loja Maker Market -->
              <a
                href="https://loja.makermarket.com"
                target="_blank"
                class="text-decoration-none d-block mb-2 hover-opacity"
              >
                <h3 class="text-subtitle-1 text-left" style="color: #777">
                  Loja Maker Market
                </h3>
                <p class="text-black text-left text-caption mt-2">
                  Conheça nossa revenda de impressoras, filamentos e insumos
                  para Makers
                </p>
              </a>

              <!-- M.A.K.E.R. LAB -->
              <a
                href="https://lab.makermarket.com"
                target="_blank"
                class="text-decoration-none d-block mt-4 hover-opacity"
              >
                <h3 class="text-subtitle-1 text-left" style="color: #777">
                  M.A.K.E.R. LAB
                </h3>
                <p class="text-black text-left text-caption mt-2">
                  Nosso laboratório de pesquisa: Conheça nossas pesquisas
                  científicas em andamento e futuras
                </p>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-6" />
      <v-row class="align-center">
        <v-col cols="12" md="12" class="footer-text mt-4 text-center">
          <v-btn
            tag="router-link"
            :to="{ path: '/legal/politica-de-privacidade' }"
            variant="text"
            target="_blank"
          >
            Política de privacidade
          </v-btn>
          <v-btn
            tag="router-link"
            :to="{ path: '/legal/termos-de-uso' }"
            variant="text"
            target="_blank"
          >
            Termos de Uso
          </v-btn>
          <v-col cols="12">
            <!-- ícones sociais -->
            <v-btn
              icon
              variant="text"
              class="mx-1"
              color="#0A66C2"
              :href="'https://www.linkedin.com/company/makermarket/'"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>

            <v-btn
              icon
              variant="text"
              class="mx-1"
              color="#E4405F"
              :href="'https://www.instagram.com/makermarket.br/'"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <v-icon>mdi-instagram</v-icon>
            </v-btn>

            <v-btn
              icon
              variant="text"
              class="mx-1"
              color="#1877F2"
              :href="'https://www.facebook.com/p/Maker-Market-61565747491652/'"
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
            >
              <v-icon>mdi-facebook</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <p class="footer-text mb-0">
              © {{ new Date().getFullYear() }} Maker Market — Todos os direitos
              reservados
            </p>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "CopyrightFooter",
  data() {
    return {
      logos: [
        require("@/assets/logos/logo3.png"),
        require("@/assets/logos/logo5.png"),
        require("@/assets/logos/logo1.png"), // última com texto
      ],
    };
  },
  computed: {
    topLogos() {
      return this.logos.slice(0, -1); // todas exceto a última
    },
    lastLogo() {
      return this.logos[this.logos.length - 1]; // só a última
    },
  },
};
</script>

<style scoped>
.copyright-footer {
  background-color: #f5f5f5;
  text-align: center;
  padding: 24px 16px;
  width: 100vw;
}

.footer-logo {
  width: 100%;
  margin-bottom: 12px;
}

.footer-text {
  font-size: 14px;
  color: #777;
}

.hover-opacity:hover {
  opacity: 0.7;
  transition: opacity 0.2s ease-in-out;
}
</style>
